import { applyMiddleware, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';

import rootSaga from './rootSaga';
import rootReducer from './rootReducer';

export const history = createBrowserHistory();

const rootReducerInstance = rootReducer(history);

const configureStore = async () => {
  const persistConfig = {
    key: 'root',
    storage,
    whitelist: [],
  };

  const sagaMiddleware = createSagaMiddleware();

  const persistedReducer = persistReducer(persistConfig, rootReducerInstance);

  const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(sagaMiddleware, routerMiddleware(history))));

  sagaMiddleware.run(rootSaga);

  const persistor = persistStore(store);

  return { store, persistor };
};

export default configureStore;
